import React from "react";
import { isUndefined } from "lodash";

import cardicon from "../../../../../assets/card-icon.svg";
import { Util } from "../../../../../../../../helpers/util";

const AutoDebitDetails = ({ data = {} }) => {
  let { currency } = Util.getCurrency();
  let name;
  let last_four;
  let balance;

  switch (data.payment_method) {
    case "dollar_wallet": {
      name = "OVest Dollar Wallet";
      balance = data.dollar;
      currency = "$";
      break;
    }
    case "card": {
      name = data.meta.name;
      last_four = data.meta.last_four;
      break;
    }
    default:
      name = "OVest Wallet";
      balance = data.ovest;
  }

  return (
    <div>
      <div className="switch-account-balance">
        <img src={cardicon} alt="" srcset="" className />
        <div className="ovest-wallet-main">
          <h5 className="mb-4 wallet-title">{name}</h5>
          {!isUndefined(balance) && (
            <p className="investamount-balance mt-3">
              Balance: {currency} {Util.formatMoneyNumber(balance)}
              {/* {ovest} */}
            </p>
          )}

          {last_four && (
            <p className="investamount-balance mt-3">**** {last_four}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default AutoDebitDetails;
